"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Dropdown = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Dropdown = ({
  options,
  className,
  colour,
  size,
  ...rest
}) => {
  let baseClass = "sp-select sp-pl--12 sp-pr--12 sp-pt--8 sp-pb--8";
  let classes = (0, _classnames.default)(baseClass, className, size, colour);

  const renderOption = () => {
    return options.map((item, i) => /*#__PURE__*/_react.default.createElement("option", {
      label: item.text,
      value: item.value,
      key: i
    }));
  };

  return /*#__PURE__*/_react.default.createElement("select", _extends({
    className: classes
  }, rest), renderOption());
};

exports.Dropdown = Dropdown;
Dropdown.defaultProps = {
  colour: "neutral",
  size: "large"
};
Dropdown.propTypes = {
  className: _propTypes.default.string,
  colour: _propTypes.default.oneOf(_utils.enums.colours),
  text: _propTypes.default.string.isRequired,
  size: _propTypes.default.oneOf(_utils.enums.dropdownSizes),
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    value: _propTypes.default.string
  }))
};
var _default = Dropdown;
exports.default = _default;